import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { toggleMegamenu, toggleSearchBar, toggleNotificationBar, setOffcanvas } from '../../actions/settingsAction';
import { logOut } from '../Authentication/logout';
import logo from '../../assets/images/logo.png';
import { baseUrl, ROUTE_BASE_URL } from '../../api/common';
import { useUser } from '../AdminUsers/UserContext';
import axios from 'axios';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(relativeTime);

const Header = ({ toggleMegamenu, isMegaMenu, toggleNotificationBar, toggleSearchBar, setOffcanvas, offcanvas }) => {

  const { adminName, adminProfile } = useUser();

  const [showDropdown, setShowDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(0);

  const scrollProgress = () => {
    const scrollPx = document.documentElement.scrollTop;
    const winHeightPx = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    setScrolled(`${(scrollPx / winHeightPx) * 100}%`);
  };

  window.addEventListener("scroll", scrollProgress);

  const handleMenuClick = () => {
    setShowDropdown(false);
  };

  const notifications = [
    {
      id: 1,
      type: "success",
      icon: "fa-thumbs-o-up",
      color: "bg-green",
      message: "Thank you! Your payment of <b>5000</b> for <b>Membership</b> was successful. Transaction ID: [Transaction ID]."
    },
    {
      id: 2,
      type: "failed",
      icon: "fa-thumbs-o-down",
      color: "bg-danger",
      message: "Your payment of <b>5000</b> was unsuccessful. Please try again or contact support."
    },
    {
      id: 3,
      type: "pending",
      icon: "fa-info-circle",
      color: "bg-warning",
      message: "Your payment of <b>5000</b> is currently pending. Please wait or contact support for assistance."
    },
    {
      id: 4,
      type: "registration_success",
      icon: "fa-check-circle",
      color: "bg-green",
      message: "Welcome aboard! Your registration is complete. Explore and enjoy our services."
    },
    {
      id: 5,
      type: "registration_failed",
      icon: "fa-times-circle",
      color: "bg-danger",
      message: "We couldn’t complete your registration. Please try again or contact support."
    },
    {
      id: 6,
      type: "registration_pending",
      icon: "fa-info-circle",
      color: "bg-warning",
      message: "The registration is awaiting further action, like email verification or admin approval."
    },
    {
      id: 7,
      type: "registration_incomplete",
      icon: "fa-times-circle",
      color: "bg-danger",
      message: "The user began the registration process but did not complete all required steps."
    }
  ];

  const [notificationData, setNotificationData] = useState([]);

  function getNotificationIcon(type) {
    switch (type) {
      case 1:
        return "fa-info-circle";
      case 2:
        return "fa-times-circle";
      default:
        return "fa-info-circle";
    }
  }
  function getNotificationColor(type) {
    switch (type) {
      case 1:
        return "bg-green";
      case 2:
        return "bg-warning";
      case 3:
        return "bg-green";
      default:
        return "bg-warning";
    }
  }

  const fetchNotificationData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/notification_list`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: localStorage.getItem('access_token'),
        },
      });

      if (response.data.status) {
        const data = response.data.data.map((item) => ({
          ...item,
          id: item.id,
          type: item.application_status || "",
          icon: getNotificationIcon(item.application_status),
          color: getNotificationColor(item.application_status),
          message: `${item.status_name} by ${item.first_name} ${item.last_name}` || ""
        }));
        setNotificationData(data);
      } else {
        console.error('Error: Failed to fetch user data');
      }
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  };

  function convertNotificationDate(notifyDate) {
    const date = dayjs.utc(notifyDate);
    const now = dayjs();

    if (now.diff(date, "days") > 0) {
      return date.format("DD MMM");
    }
    if (now.diff(date, "hours") > 0) {
      return `${now.diff(date, "hours")} hr`;
    }
    if (now.diff(date, "minutes") > 0) {
      return `${now.diff(date, "minutes")} minutes ago`;
    }
    if (now.diff(date, "seconds") > 0) {
      return `${now.diff(date, "seconds")} seconds ago`;
    }
    return "Just now";
  }

  const changeNotificationReadStatus = async (notificationId, readStatus) => {
    if (readStatus === 0) {
      try {
        const response = await axios.post(`${baseUrl}/api/notification_status_update`,
          { id: notificationId },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );

        if (response.data.status) {
          console.log(response.data, "response.data");
          fetchNotificationData();
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error('Error fetching users data:', error);
      }
    }
  }

  useEffect(() => {
    fetchNotificationData();
  }, []);


  return (
    <>
      <nav className="navbar top-navbar">
        <div className="container-fluid">
          <div className="navbar-left">
            <div className="navbar-btn">
              <Link>
                <img src={logo} width={90} alt='Amasi' className="img-fluid logo" />
              </Link>
              <button type="button" className="btn-toggle-offcanvas" onClick={() => setOffcanvas(!offcanvas)}>
                <i className="lnr lnr-menu fa fa-bars"></i>
              </button>
            </div>
            <ul className="nav navbar-nav">
              <li className="dropdown">
                <span className="dropdown-toggle icon-menu" data-toggle="dropdown">
                  <i className="icon-bell"></i>
                  {notificationData.filter((data) => data.read_status === 0).length > 0 && <span className="notification-dot bg-azura">{notificationData.filter((data) => data.read_status === 0).length}</span>}
                </span>
                <ul className="dropdown-menu feeds_widget vivify fadeIn notification_overflow">
                  <li className="header blue">{notificationData.filter((data) => data.read_status === 0).length > 0 ? `You have ${notificationData.length} New Notifications` : "Notifications"}</li>
                  {notificationData.map((notification) => (
                    <li onClick={() => changeNotificationReadStatus(notification.id, notification.read_status)} key={notification.id} className={`${notification.read_status === 0 ? "active_div_notification" : ''}`}>
                      <Link to={`${ROUTE_BASE_URL}/`}>
                        <div className={`feeds-left ${notification.color} text-white`}>
                          <i className={`fa ${notification.icon}`}></i>
                        </div>
                        <div className="feeds-body custom_date">
                          <div className='message_custom'>
                            <h4 className="title text-dark" dangerouslySetInnerHTML={{ __html: notification.message }}></h4>
                          </div>
                          <div className='notification_date_custom float-right text-muted'>
                            {convertNotificationDate(notification.created_on)}
                          </div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </div>
          <div className="navbar-right ">
            <div className="user-account d-flex">
              <div className="user_div">
                <img src={`${adminProfile ? adminProfile : "../../assets/images/sm/avatar1.jpg"}`}
                  width={50}
                  height={50}
                  className="user-photo rounded img-thumbnail rounded-circle profile-menu-size" alt="User Profile" />
              </div>
              <div className="dropdown">
                <span>Welcome,</span>
                <br />
                <Dropdown show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)} className="ml-0">
                  <Dropdown.Toggle variant="success" id="dropdown-basic" className="user-name left_dropdown_btn">
                    <strong>{adminName || ""}</strong>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/my-profile`} onClick={handleMenuClick}>
                      <i className="icon-user"></i> My Profile
                    </Link>
                    {/* <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={handleMenuClick}>
                                            <i className="icon-envelope-open"></i> Messages
                                        </Link>
                                        <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/`} onClick={handleMenuClick}>
                                            <i className="icon-settings"></i> Settings
                                        </Link> */}
                    <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/settings`} onClick={handleMenuClick}>
                      <i className="icon-settings"></i> Settings
                    </Link>
                    <Link className="dropdown-item" to={`${ROUTE_BASE_URL}/login`} onClick={() => {
                      logOut();
                      handleMenuClick();
                    }}>
                      <i className="icon-power"></i> Logout
                    </Link>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <div className="progress-container">
          <div style={{ width: scrolled }} className="progress-bar" id="myBar"></div>
        </div>
      </nav>
    </>
  );
};

const mapStateToProps = state => ({
  isMegaMenu: state.settings.isMegaMenu,
  offcanvas: state.settings.offcanvas,
});

const mapDispatchToProps = dispatch => ({
  toggleMegamenu: (e) => dispatch(toggleMegamenu(e)),
  toggleSearchBar: (e) => dispatch(toggleSearchBar(e)),
  toggleNotificationBar: (e) => dispatch(toggleNotificationBar(e)),
  setOffcanvas: (e) => dispatch(setOffcanvas(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
